export default __webpack_public_path__ + "static/media/02b3f97a-406d-43cb-885c-ba5233577cad.41e2df0c.woff2";